module.exports = "/assets/data/b364d922cfcee94d39a452c94370a98e-SW4.data.json";